import * as api from "../api";
import { Banner } from "@dbn/omnichannel-design-system-g4p";
import { pipe } from "fp-ts/function";
import { useFormatMessage } from "../../../intl";
import { array, boolean, option } from "fp-ts";

type Props = {
  currentInsuranceType: api.CreditProtectionInsuranceType;
  cpiPackageList: api.CPIPackageList;
  onClick: () => unknown;
};

export function CPIBanner(props: Props) {
  const formatMessage = useFormatMessage();

  const bannerError = (
    <Banner
      content={pipe(
        props.currentInsuranceType === "None",
        boolean.fold(
          () =>
            pipe(
              props.cpiPackageList.options,
              array.findFirst(
                ({ type }) => type === props.currentInsuranceType
              ),
              option.fold(
                () =>
                  formatMessage(
                    "StandardLoan.CustomerOffer.insuranceNotIncluded"
                  ),
                ({ name }) =>
                  formatMessage(
                    "StandardLoan.CustomerOffer.insuranceIncluded",
                    {
                      insurance: formatMessage(name),
                    }
                  )
              )
            ),
          () => formatMessage("StandardLoan.CustomerOffer.insuranceNotIncluded")
        )
      )}
      title={option.none}
      inline={true}
      actions={pipe(
        props.currentInsuranceType === "None",
        boolean.fold(
          () => {
            return option.some([
              {
                label: formatMessage(
                  "StandardLoan.CustomerOffer.insuranceIncludedButton"
                ),
                variant: "text",
                action: props.onClick,
              },
            ]);
          },
          () => {
            return option.some([
              {
                label: formatMessage(
                  "StandardLoan.CustomerOffer.insuranceNotIncludedButton"
                ),
                variant: "text",
                action: props.onClick,
              },
            ]);
          }
        )
      )}
      type={"error"}
    />
  );

  const bannerInformative = (
    <Banner
      content={pipe(
        props.currentInsuranceType === "None",
        boolean.fold(
          () =>
            pipe(
              props.cpiPackageList.options,
              array.findFirst(
                ({ type }) => type === props.currentInsuranceType
              ),
              option.fold(
                () =>
                  formatMessage(
                    "StandardLoan.CustomerOffer.insuranceNotIncluded"
                  ),
                ({ name }) =>
                  formatMessage(
                    "StandardLoan.CustomerOffer.insuranceIncluded",
                    {
                      insurance: formatMessage(name),
                    }
                  )
              )
            ),
          () => formatMessage("StandardLoan.CustomerOffer.insuranceNotIncluded")
        )
      )}
      title={option.none}
      inline={true}
      onDismiss={option.none}
      actions={pipe(
        props.currentInsuranceType === "None",
        boolean.fold(
          () => {
            return option.some([
              {
                label: formatMessage(
                  "StandardLoan.CustomerOffer.insuranceIncludedButton"
                ),
                variant: "text",
                action: props.onClick,
              },
            ]);
          },
          () => {
            return option.some([
              {
                label: formatMessage(
                  "StandardLoan.CustomerOffer.insuranceNotIncludedButton"
                ),
                variant: "text",
                action: props.onClick,
              },
            ]);
          }
        )
      )}
      type={"informative"}
    />
  );

  return pipe(
    props.currentInsuranceType === "None",
    boolean.fold(
      () => bannerInformative,
      () => bannerError
    )
  );
}
